export enum SAME_SITE_OPTIONS {
  STRICT = "strict",
  LAX = "lax",
  NONE = "none",
}
